import React from 'react'
import PrintBillReceipt from './PrintBillReceipt/PrintBillReceipt'


const StatusManageRegist_6 = ({ DataRegister }) => {
  return (
    <PrintBillReceipt DataRegister={DataRegister} />
  )
}

export default StatusManageRegist_6